import { ReactComponent as MacbookIcon } from "../../../../assets/images/devices/laptop_chromebook.svg";
import { ReactComponent as SmartphoneIcon } from "../../../../assets/images/devices/phone_android.svg";
import { ReactComponent as TabletIcon } from "../../../../assets/images/devices/tablet_android.svg";
import { ReactComponent as SmartwatchIcon } from "../../../../assets/images/devices/watch.svg";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import { DEVICE_TYPES } from "../../../../pages/smartDeviceInsurancePages/newSmartDevicePolicy/data";

const DeviceTypeSelector = ({ selectedDevice, onDeviceSelect }) => {
  const translate = useLanguageTranslate();

  const deviceOptions = [
    {
      type: DEVICE_TYPES.SMARTPHONE,
      IconComponent: SmartphoneIcon,
      label_en: "Smartphone",
      label_ar: "هاتف ذكي",
    },
    {
      type: DEVICE_TYPES.TABLET,
      IconComponent: TabletIcon,
      label_en: "Tablet",
      label_ar: "جهاز لوحي",
    },
    {
      type: DEVICE_TYPES.SMARTWATCH,
      IconComponent: SmartwatchIcon,
      label_en: "Smartwatch",
      label_ar: "ساعة ذكية",
    },
    {
      type: DEVICE_TYPES.MACBOOK,
      IconComponent: MacbookIcon,
      label_en: "Macbook",
      label_ar: "ماك بوك",
    },
  ];

  return (
    <div className="device-type-selector mb-6">
      <label className="block text-[#48535B] text-base not-italic font-normal leading-5 tracking-[-0.14px] mb-3">
        {translate("Device Type", "نوع الجهاز")}
      </label>
      <div className="grid grid-cols-4 gap-4 max767:grid-cols-2">
        {deviceOptions.map((device) => {
          const isSelected = selectedDevice === device.type;
          const IconComponent = device.IconComponent;
          return (
            <button
              key={device.type}
              type="button"
              onClick={() => onDeviceSelect(device.type)}
              className={`
                flex flex-col items-center justify-center gap-3 p-4 rounded-md border transition-all
                min-h-[120px] max767:min-h-[100px]
                ${
                  isSelected
                    ? "border-[#00719A] bg-[#EDFAFF]"
                    : "border-[#E5E9EB] bg-white hover:border-[#00719A] hover:bg-[#F6F8F9]"
                }
              `}
            >
              <div
                className={`
                  w-12 h-12 flex items-center justify-center rounded-lg
                  ${isSelected ? "text-[#00719A]" : "text-[#48535B]"}
                `}
              >
                <IconComponent className="w-10 h-10" />
              </div>
              <span
                className={`
                  text-center text-base not-italic leading-5
                  ${isSelected ? "text-[#00719A] font-semibold" : "text-[#252C32] font-normal"}
                `}
              >
                {translate(device.label_en, device.label_ar)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DeviceTypeSelector;
